import React, { Fragment, useState } from "react"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import Button from "@material-ui/core/Button"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"
import FormControl from "@material-ui/core/FormControl"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import InputLabel from "@material-ui/core/InputLabel"
import MenuItem from "@material-ui/core/MenuItem"
import Select from "@material-ui/core/Select"
import Switch from "@material-ui/core/Switch"
import SimplePopover from "../build/btnInfo"
// Translations
import { useTranslation } from "react-i18next"
import color_legend from "../../images/color_legend.png"
import Rainbow from "../Rainbow"
import { InfoOutlined } from "@material-ui/icons"
import IconButton from "@material-ui/core/IconButton"
import CloseIcon from "@material-ui/icons/Close"

const useStyles = makeStyles((theme) => ({
	infoIcon: {
		width: 13,
		height: 13,
		cursor: "pointer",
	},
	closeButton: {
		position: "absolute",
		right: theme.spacing(1),
		top: theme.spacing(1),
		color: theme.palette.grey[500],
	},
}))

const InfoDialog = ({ btninfo }) => {
	const classes = useStyles()
	const theme = useTheme()
	/* ******************* TRANSALATIONS ******************* */
	const [t, i18n] = useTranslation("global")
	/* ******************* END TRANSALATIONS ******************* */

	/* ******************* CUSTOM FUNCTIONS ******************* */
	const handleClickOpen = () => {
		setOpen(true)
	}

	const handleClose = () => {
		setOpen(false)
	}
	/* ******************* END CUSTOM FUNCTIONS ******************* */

	/* ******************* REACT STATES ******************* */
	// Component states
	const [open, setOpen] = useState(false)
	const [fullWidth, setFullWidth] = useState(true)
	const [maxWidth, setMaxWidth] = useState("sm")
	/* ******************* END REACT STATES ******************* */

	return (
		<Fragment>
			{/* <Button className="btn btn-default btn-sm rounded-circle" style={{ boxShadow: "none" }} onClick={handleClickOpen}>
				<i className="bi bi-question-circle-fill" style={{ fontSize: "18px" }}></i>
			</Button> */}
			<InfoOutlined className={classes.infoIcon} onClick={handleClickOpen} />
			<Dialog fullWidth={fullWidth} maxWidth={maxWidth} open={open} onClose={handleClose} aria-labelledby="max-width-dialog-title">
				<DialogTitle id="max-width-dialog-title" style={{ borderBottom: `1px solid ${theme.palette.grey[300]}` }}>
					{btninfo === "searchContext" ? t("search.info_searchbox") : null}
					{btninfo === "loadSavedSearch" ? t("search.info_load_saved_search") : null}
					{btninfo === "infoFiltersSearch" ? t("search.info_filters_title") : null}
					{btninfo === "infoFiltersPrioritySearch" ? t("search.info_priority_title") : null}
					{btninfo === "searchBuild" ? "Build concepts" : null}
					{btninfo === "filtersBuild" ? t("concept.popup_msg.title") : null}
					{btninfo === "termsBuild" ? "Terms List" : null}
					{btninfo === "target" ? "Target" : null}
					{btninfo === "includeSpecific" ? "Include specific" : null}
					{btninfo === "ignoreRelated" ? "Ignore related" : null}
					{btninfo === "ignoreSpecific" ? "Remove from search" : null}
					{btninfo === "searchContextTimeline" ? "Create Timeline" : null}
					{btninfo === "filtersTimeline" ? "Filters options - Create Timeline" : null}
					{btninfo === "conceptsTable" ? "All concepts and searches shown" : null}
					{btninfo === "filtersDocuments" ? "Filters options - View Documents" : null}
				</DialogTitle>
				<IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
					<CloseIcon />
				</IconButton>
				<DialogContent>
					<DialogContentText color={theme.palette.text.primary}>
						{btninfo === "searchContext" ? (
							<ol>
								<li>{t("search.info_searchbox_content")}</li>
								<li>{t("search.info_searchbox_content2")}</li>
							</ol>
						) : null}
						{btninfo === "loadSavedSearch" ? (
							<ul>
								<li>{t("search.info_searchbox_load")}</li>
							</ul>
						) : null}
						{btninfo === "infoFiltersSearch" ? (
							<div className="col-12 divBlock">
								<div className="col-12 divBlock mt-3">
									<h6 className="boldInfoDialog">{t("search.info_filters")}</h6>
								</div>
								<div className="col-12 divBlock">
									<span>{t("search.info_filters_content")}</span>
								</div>
								<div className="col-12 divBlock mt-3">
									<h6 className="boldInfoDialog">{t("search.info_types")}</h6>
								</div>
								<div className="col-12 divBlock">
									<span>{t("search.info_types_content")}</span>
								</div>
								<div className="col-12 divBlock mt-3">
									<h6 className="boldInfoDialog">{t("search.info_types2")}</h6>
								</div>
								<div className="col-12 divBlock">
									<span>{t("search.info_types_content2")}</span>
								</div>
							</div>
						) : null}
						{btninfo === "infoFiltersPrioritySearch" ? (
							<div className="col-12 divBlock">
								<div className="col-12 divBlock mt-3">
									<span>{t("search.info_priority")}</span>
								</div>
								<div className="col-12 divBlock">
									<span>{t("search.info_priority_content")}</span>
								</div>
								<div className="col-12 divBlock">
									<ul>
										<li>
											Standard tags
											<ol>
												<li>Important</li>
												<li>Undecided</li>
												<li>Not Relevant</li>
											</ol>
										</li>
										<li>
											Custom tags
											<ol>
												<li>Create your own custom tag name it and choose color</li>
												<li>The custom tag will appear in the “tag-filter” menu</li>
											</ol>
										</li>
									</ul>
								</div>
							</div>
						) : null}
						{btninfo === "searchBuild" ? (
							<div className="col-12 divBlock">
								<div className="col-12 divBlock mt-3">
									<h6 className="boldInfoDialog">Search Concept</h6>
								</div>
								<div className="col-12 divBlock">
									<span>
										Insert a word, review number of hits and synonyms and start to build a concept including all the
										documents you are looking for. Use the intuitive Word Cloud to help fine-tune your search and
										combination of searches, before you finalize and store your Built Concepts.
									</span>
								</div>
								<div className="col-12 divBlock mt-3">
									<h6 className="boldInfoDialog">Share Concept</h6>
								</div>
								<div className="col-12 divBlock">
									<span>
										Share the concept you have built with the rest of your team (as part of sharing the review process
										with the team).
									</span>
								</div>
								<div className="col-12 divBlock mt-3">
									<h6 className="boldInfoDialog">Save Concept</h6>
								</div>
								<div className="col-12 divBlock">
									<span>Name your concept search and save it with a relevant name.</span>
								</div>
								<div className="col-12 divBlock mt-3">
									<h6 className="boldInfoDialog">Load Saved Concept</h6>
								</div>
								<div className="col-12 divBlock">
									<span>
										Load earlier saved concepts and directly access relevant documents in the concept. Helps you keep
										track of previous searches and review of relevant documents linked to the search.
									</span>
								</div>
							</div>
						) : null}
						{btninfo === "filtersBuild" ? (
							<div className="col-12 divBlock">
								<div className="col-12 divBlock">
									<span>{t("concept.popup_msg.description")}</span>
								</div>
								<div className="col-12 divBlock mt-3">
									<h6 className="boldInfoDialog">{t("concept.popup_msg.heading_1.title")}</h6>
								</div>
								<div className="col-12 divBlock">
									<span>{t("concept.popup_msg.heading_1.description")}</span>
									<br />
									<ul>
										<li>
											<span>{t("concept.popup_msg.heading_1.point_1")}</span>
										</li>
										<li>
											<span>{t("concept.popup_msg.heading_1.point_2")}</span>
										</li>
									</ul>
								</div>
								<div className="col-12 divBlock mt-3">
									<h6 className="boldInfoDialog">{t("concept.popup_msg.heading_2.title")}</h6>
								</div>
								<div className="col-12 divBlock">
									<span>{t("concept.popup_msg.heading_2.description")}</span>
								</div>
								<div className="col-12 divBlock mt-3">
									<h6 className="boldInfoDialog">{t("concept.popup_msg.heading_3.title")}</h6>
								</div>
								<div className="col-12 divBlock">
									<span>{t("concept.popup_msg.heading_3.description")}</span>
								</div>
							</div>
						) : null}
						{btninfo === "termsBuild" ? (
							<div className="col-12 divBlock">
								<div className="col-12 divBlock mt-3">
									<h6 className="boldInfoDialog">Color Legend</h6>
								</div>
								<Rainbow showHeatmapColors={true} />
								<div className="col-12 divBlock mt-3">
									<h6 className="boldInfoDialog">Heatmap</h6>
								</div>
								<div className="col-12 divBlock">
									<p>
										<span>
											Visualize the AI engines relativity index between searched word and other proposed
											synonyms/terms in the data set. Red is high relatedness to green as neutral to blue for low
											relatedness. Black is targeted terms. The color grey is ignored terms which are excluded terms
											and words.{" "}
										</span>
									</p>
									<p>
										<span>The Word Cloud use similar color coding (does not highlight ignored terms).</span>
									</p>
								</div>
								<div className="col-12 divBlock mt-3">
									<h6 className="boldInfoDialog">Hits</h6>
								</div>
								<div className="col-12 divBlock">
									<span>
										Statistical hits of the searched words or word combinations and their synonyms. Visualized by the
										Word Cloud font size.
									</span>
								</div>
								<div className="col-12 divBlock mt-3">
									<h6 className="boldInfoDialog">Target Terms</h6>
								</div>
								<div className="col-12 divBlock">
									<span>
										Tick the words you want to target as relevant for your search or concepts. The AI engine will
										include related words. Will be indicated by black color.{" "}
									</span>
								</div>
								<div className="col-12 divBlock mt-3">
									<h6 className="boldInfoDialog">Ignore Related</h6>
								</div>
								<div className="col-12 divBlock">
									<span>
										Tick the words you want to ignore from your search or concepts. The AI engine will ignore your
										selected words and related words. Will be indicated by grey color.{" "}
									</span>
									<br></br>
									<br></br>
									<span>
										IMPORTANT: Using “Ignore related” means that all files and documents containing the selected AND
										related words will be removed from the concept. Carefully consider which words to eliminate from the
										concept.
									</span>
								</div>
								<div className="col-12 divBlock mt-3">
									<h6 className="boldInfoDialog">Include Specific</h6>
								</div>
								<div className="col-12 divBlock">
									<span>
										Tick the exact words you want to target to narrow your search and concepts. Will be indicated by
										black color.
									</span>
								</div>
								<div className="col-12 divBlock mt-3">
									<h6 className="boldInfoDialog">Ignore Specific</h6>
								</div>
								<div className="col-12 divBlock">
									<span>
										Tick the exact words you want to target to narrow your search or concepts. Will be indicated by grey
										color.{" "}
									</span>
									<br></br>
									<br></br>
									<span>
										IMPORTANT: Using “Ignore specific” means that all files and documents containing the selected words
										will be removed from the concept. Carefully consider which words to eliminate from the concept.
									</span>
								</div>
								<div className="col-12 divBlock mt-3">
									<h6 className="boldInfoDialog">Color Legend</h6>
								</div>
								<div className="col-12 divBlock">
									<span>Visualizes the different colors of the heatmap from target terms to ignored terms</span>
								</div>
							</div>
						) : null}
						{btninfo === "target"
							? "Show the words you wanted to target as relevant for your search or concepts. The AI engine will include related words."
							: null}
						{btninfo === "includeSpecific"
							? "Show the exact words you wanted to target to narrow your search and concepts."
							: null}
						{btninfo === "ignoreRelated"
							? "Show the words you wanted to ignore from your search or concepts. The AI engine will ignore related words."
							: null}
						{btninfo === "ignoreSpecific" ? "Remove this term from the concept." : null}
						{btninfo === "searchContextTimeline" ? (
							<div className="col-12 divBlock">
								<div className="col-12 divBlock">
									<span>
										Create a timeline based on a word search or saved concepts search. Find out what happened when and
										how often. This may help you to narrow down your search to focus on a given time period.
									</span>
								</div>
								<div className="col-12 divBlock mt-3">
									<h6 className="boldInfoDialog">Files and Documents</h6>
								</div>
								<div className="col-12 divBlock">
									<span>View relevant files and documents from the saved concepts or search.</span>
								</div>
								<div className="col-12 divBlock mt-3">
									<h6 className="boldInfoDialog">Dates</h6>
								</div>
								<div className="col-12 divBlock">
									<span>
										Target relevant files and documents by adjusting the graph from date to date in a dynamic search
										mode.
									</span>
								</div>
							</div>
						) : null}
						{btninfo === "filtersTimeline" ? (
							<div className="col-12 divBlock">
								<div className="col-12 divBlock mt-3">
									<h6 className="boldInfoDialog">Filter and highlight</h6>
								</div>
								<div className="col-12 divBlock">
									<span>Filter and highlight relevant information in files and documents in the relevant timeline.</span>
								</div>
								<div className="col-12 divBlock mt-3">
									<h6 className="boldInfoDialog">File types</h6>
								</div>
								<div className="col-12 divBlock">
									<span>
										Select the file types you want to view or exclude file types from your search to narrow it further.
									</span>
								</div>
								<div className="col-12 divBlock mt-3">
									<h6 className="boldInfoDialog">Start date / End date</h6>
								</div>
								<div className="col-12 divBlock">
									<span>Set the relevant search period to narrow down the documents to review.</span>
								</div>
								<div className="col-12 divBlock mt-3">
									<h6 className="boldInfoDialog">Tag filter</h6>
								</div>
								<div className="col-12 divBlock">
									<div className="col-12 divBlock mt-3">
										<span>{t("search.info_priority")}</span>
									</div>
									<div className="col-12 divBlock">
										<span>{t("search.info_priority_content")}</span>
									</div>
									<div className="col-12 divBlock">
										<ul>
											<li>
												Standard tags
												<ol>
													<li>Important</li>
													<li>Undecided</li>
													<li>Not Relevant</li>
												</ol>
											</li>
											<li>
												Custom tags
												<ol>
													<li>Create your own custom tag name it and choose color</li>
													<li>The custom tag will appear in the “tag-filter” menu</li>
												</ol>
											</li>
										</ul>
									</div>
								</div>
							</div>
						) : null}
						{btninfo === "conceptsTable" ? (
							<div className="col-12 divBlock">
								<div className="col-12 divBlock mt-3">
									<h6 className="boldInfoDialog">Your saved concepts</h6>
								</div>
								<div className="col-12 divBlock">
									<span>View all the files and documents under the concepts you have saved in your search</span>
								</div>
								<div className="col-12 divBlock mt-3">
									<h6 className="boldInfoDialog">Concepts shared by your team</h6>
								</div>
								<div className="col-12 divBlock">
									<span>View all the files and documents shared with you by the team.</span>
								</div>

								<div className="col-12 divBlock mt-3">
									<h6 className="boldInfoDialog">Your saved Searches</h6>
								</div>
								<div className="col-12 divBlock">
									<span>View all the saved searches</span>
								</div>
								<div className="col-12 divBlock mt-3">
									<h6 className="boldInfoDialog">Searches shared by your team</h6>
								</div>
								<div className="col-12 divBlock">
									<span>View all saves searches shared with you by the team</span>
								</div>
							</div>
						) : null}
						{btninfo === "filtersDocuments" ? (
							<div className="col-12 divBlock">
								<div className="col-12 divBlock mt-3">
									<h6 className="boldInfoDialog">Filters</h6>
								</div>
								<div className="col-12 divBlock">
									<span>Filter and highlight relevant information and specific words in the files and document.</span>
								</div>
								<div className="col-12 divBlock mt-3">
									<h6 className="boldInfoDialog">File type</h6>
								</div>
								<div className="col-12 divBlock">
									<span>
										Select and sort according to file type in the view documents if you are looking for a specific
										format for further review.
									</span>
								</div>
								<div className="col-12 divBlock mt-3">
									<h6 className="boldInfoDialog">Priority</h6>
								</div>
								<div className="col-12 divBlock">
									<span>
										Sort files and documents according to priority – red, yellow, green or by custom tags. By reviewing
										the color coding you can keep track if relevant documents have been reviewed by your team. You can
										also sort and download documents according to relevance after review.
									</span>
								</div>
								<div className="col-12 divBlock mt-3">
									<h6 className="boldInfoDialog">Download documents</h6>
								</div>
								<div className="col-12 divBlock">
									<span>
										Download files and documents sorted by priority or by search results for easy transfer to case file,
										submissions and other relevant third parties.
									</span>
								</div>

								<div className="col-12 divBlock mt-3">
									<h6 className="boldInfoDialog">Bulk Download </h6>
								</div>
								<div className="col-12 divBlock">
									<span>Download several documents and files </span>
								</div>

								<div className="col-12 divBlock mt-3">
									<h6 className="boldInfoDialog">Bulk Share</h6>
								</div>
								<div className="col-12 divBlock">
									<span>Share several documents and searches with your team</span>
								</div>
							</div>
						) : null}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					{/* <Button onClick={handleClose} color="primary">
						{t("search.info_searchbox_close")}
					</Button> */}
				</DialogActions>
			</Dialog>
		</Fragment>
	)
}

export default InfoDialog
